import newStudentsImg from "../../assets/img/ankete/anketa-za-nove-studente.webp";
import teachingImg from "../../assets/img/ankete/anketa-o-nastavi-i-nastavnicima.webp";
import assessmentImg from "../../assets/img/ankete/anketa-o-nacinu-ocjenjivanja.webp";
import studyProcessImg from "../../assets/img/ankete/anketa-za-studente-o-opstim-aspektima-studijskog-procesa.webp";
import internshipImg from "../../assets/img/ankete/anketa-za-studente-o-obaveznoj-praksi.webp";
import studentServiceLibraryImg from "../../assets/img/ankete/anketa-za-studente-o-radu-studentske-sluzbe-i-biblioteke.webp";
import governanceStudentsImg from "../../assets/img/ankete/anketa-za-studente-o-organima-upravljanja.webp";
import governanceNonTeachingImg from "../../assets/img/ankete/anketa-za-vannastavno-osoblje-o-radu-organa-upravljanja.webp";
import alumniImg from "../../assets/img/ankete/upitnik-za-alumniste.webp";

export const SURVEY_CATEGORIES = [
  { id: "studentExperience" },
  { id: "institutionalSupport" },
  { id: "development" },
];

export const SURVEYS = [
  {
    id: "newStudents",
    category: "studentExperience",
    image: newStudentsImg,
    icon: "fas fa-user-plus",
    resultMode: "internal",
    isCommissionRecommendation: false,
  },
  {
    id: "teachingStaff",
    category: "studentExperience",
    image: teachingImg,
    icon: "fas fa-chalkboard-teacher",
    resultMode: "narrative",
    isCommissionRecommendation: false,
  },
  {
    id: "assessment",
    category: "studentExperience",
    image: assessmentImg,
    icon: "fas fa-clipboard-check",
    resultMode: "narrative",
    isCommissionRecommendation: false,
  },
  {
    id: "studyProcess",
    category: "studentExperience",
    image: studyProcessImg,
    icon: "fas fa-layer-group",
    resultMode: "narrative",
    isCommissionRecommendation: false,
  },
  {
    id: "internship",
    category: "studentExperience",
    image: internshipImg,
    icon: "fas fa-briefcase",
    resultMode: "narrative",
    isCommissionRecommendation: false,
  },
  {
    id: "studentServiceLibrary",
    category: "institutionalSupport",
    image: studentServiceLibraryImg,
    icon: "fas fa-book-reader",
    resultMode: "pending",
    isCommissionRecommendation: true,
  },
  {
    id: "governanceStudents",
    category: "institutionalSupport",
    image: governanceStudentsImg,
    icon: "fas fa-university",
    resultMode: "pending",
    isCommissionRecommendation: true,
  },
  {
    id: "governanceNonTeaching",
    category: "institutionalSupport",
    image: governanceNonTeachingImg,
    icon: "fas fa-users-cog",
    resultMode: "pending",
    isCommissionRecommendation: true,
  },
  {
    id: "alumni",
    category: "development",
    image: alumniImg,
    icon: "fas fa-user-graduate",
    resultMode: "internal",
    isCommissionRecommendation: false,
  },
];
